export default "__VITE_ASSET__iFx3y_By__"